import type { CalculationResponse, Project } from '../../gen/ejot/roofing/v1/types';
import type { LayerVisibility } from '../roof-plan-editor/render';
import { ProjectPlanOverview } from '../project-plan/ProjectPlanOverview';
import { ProjectViewer3D } from '../project-viewer/ProjectViewer3D';

export type AllRoofsOverviewMode = '2d' | 'zones' | '3d';

const DEFAULT_LAYERS: LayerVisibility = {
  'building-mass': true,
  'roof-surface': true,
  'roof-outline': true,
  'wind-zones': true,
  'zone-labels': true,
  'zone-dimensions': true,
};

/**
 * Read-only project overview.
 *
 * The project 3D path uses the same OrbitControls interaction contract as the
 * individual roof view. The project 2D paths share one pan/zoom/fit viewport
 * and render backend-authored zones, labels, pressures and dimensions.
 */
export function AllRoofsOverview({
  project,
  result,
  mode,
  activeModuleId,
  layers = DEFAULT_LAYERS,
  theme = '',
  selectedZoneId,
  onZoneSelect,
  onActiveModuleChange,
  onOpenModule,
}: {
  project: Project;
  result: CalculationResponse | undefined;
  mode: AllRoofsOverviewMode;
  activeModuleId?: string;
  layers?: LayerVisibility;
  theme?: string;
  selectedZoneId?: string;
  onZoneSelect?: (zoneId: string | undefined) => void;
  onActiveModuleChange: (moduleId: string) => void;
  onOpenModule: (moduleId: string) => void;
}) {
  if (mode === '3d') {
    return (
      <ProjectViewer3D
        project={project}
        result={result}
        activeModuleId={activeModuleId}
        detailMode="all"
        layers={layers}
        theme={theme}
        selectedZoneId={selectedZoneId}
        onZoneSelect={onZoneSelect}
        onActiveModuleChange={onActiveModuleChange}
        onOpenModule={onOpenModule}
      />
    );
  }

  return (
    <ProjectPlanOverview
      project={project}
      result={result}
      mode={mode === 'zones' ? 'zones' : '2d'}
      activeModuleId={activeModuleId}
      layers={layers}
      onActiveModuleChange={onActiveModuleChange}
      onOpenModule={onOpenModule}
    />
  );
}
